module.exports = __webpack_public_path__ + "media/images/feature/Researching-amico-ddedccd5e546a42c0a7b2360df2c00ca.png";